import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/logo.png';
import _imports_1 from '../assets/images/indexList/download.png';
import _imports_2 from '../assets/images/homePage/menu.png';
const _withScopeId = n => (_pushScopeId("data-v-71d843af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tabbar"
};
const _hoisted_2 = {
  class: "tabbar-left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "left-phone",
  id: "phone"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "13436936203", -1));
const _hoisted_6 = {
  class: "tabbar-right"
};
const _hoisted_7 = {
  key: 0,
  class: "list-row"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "background-color": "#153578"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "15px",
    "margin-right": "10px"
  }
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode(" 您可以致电联合智评客服 "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#153578"
  }
}, "13436936203"), /*#__PURE__*/_createTextVNode(" ，了解试用申请的具体情况 ")], -1));
const _hoisted_13 = {
  class: "dialog-footer"
};
import { PhoneFilled } from '@element-plus/icons-vue';
import { onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import loginDialog from '@/components/loginDialog.vue';
export default {
  __name: 'topBar',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    onMounted(() => {
      number.value = route.path;
      window.addEventListener('resize', handleResize);
      reportWindowSize();
    });
    const handleResize = () => {
      browserWindow.value = window.innerWidth;
    };
    let browserWindow = ref(0);
    watch(browserWindow, n => {
      reportWindowSize(n);
    });
    const topnav = reactive([
    // 顶部导航栏
    {
      title: '首页',
      key: 1,
      url: '/home',
      ischecked: false
    },
    // {
    //     key: 2,
    //     title: '理财指数',
    //     url: "/indexList",
    //     ischecked: false
    // },
    {
      key: 3,
      title: '服务内容',
      url: '/service',
      ischecked: false
    }, {
      key: 4,
      title: '关于联信智评',
      url: '/about',
      ischecked: false
    }, {
      key: 5,
      title: '申请试用',
      // url: '/applyProbation',
      url: '',
      ischecked: false
    }, {
      key: 6,
      title: '金融终端',
      url: "/csDownload",
      ischecked: false
    }]);
    let dialogFormVisible = ref(false); // 是否展示el-dialog
    let dialogFormVisibleApply = ref(false); // 是否展示申请试用dialog
    let number = ref('/home'); // active的导航
    let isShowList = ref(true); // 样式是否变为下拉菜单
    const reportWindowSize = n => {
      // 页面缩小tapbar，变成下拉选项 
      let leftPhone = document.getElementById('phone');
      if (document.body.clientWidth < 1090) {
        isShowList.value = false;
        browserWindow.value = n;
        leftPhone.style.display = 'none';
      } else if (document.body.clientWidth > 1113) {
        leftPhone.style.display = 'block';
        isShowList.value = true;
        browserWindow.value = n;
      } else {
        leftPhone.style.display = 'none';
        isShowList.value = true;
      }
    };
    const downloadZD = () => {
      dialogFormVisible.value = true;
    };
    const closeDialog = () => {
      dialogFormVisible.value = false;
    };
    const downEmits = () => {
      dialogFormVisible.value = false;
    };
    const goPage = item => {
      // 切换导航
      if (item.title != '申请试用') {
        number.value = item.url;
        router.push({
          path: item.url
        });
      } else {
        dialogFormVisibleApply.value = true;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(PhoneFilled), {
          style: {
            "color": "#153578"
          }
        })]),
        _: 1
      }), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_unref(isShowList) ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topnav, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.key,
          onClick: $event => goPage(item),
          class: _normalizeClass([{
            'title-active': _unref(number) == item.url
          }, "item-list"])
        }, _toDisplayString(item.title), 11, _hoisted_8);
      }), 128)), _createElementVNode("li", {
        style: {
          "color": "#153578"
        },
        onClick: downloadZD
      }, [_hoisted_9, _createTextVNode("终端下载")])])) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        class: "list-column",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "dropdown"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topnav, item => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.key,
              onClick: $event => goPage(item),
              class: _normalizeClass([{
                'title-active': _unref(number) == item.url
              }, "item-list"])
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["onClick", "class"]);
          }), 128)), _createVNode(_component_el_dropdown_item, {
            style: {
              "color": "#153578"
            },
            onClick: downloadZD
          }, {
            default: _withCtx(() => [_hoisted_11, _createTextVNode("终端下载")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }))])]), _createVNode(loginDialog, {
        dialogFormVisible: _unref(dialogFormVisible),
        onCloseDialog: closeDialog,
        onDownEmits: downEmits
      }, null, 8, ["dialogFormVisible"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogFormVisibleApply),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dialogFormVisibleApply) ? dialogFormVisibleApply.value = $event : dialogFormVisibleApply = $event),
        "close-on-click-modal": false,
        width: "460px",
        top: "16%",
        right: "20px",
        class: "login-dialog",
        title: "申请试用",
        style: {
          "border-radius": "10px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => _isRef(dialogFormVisibleApply) ? dialogFormVisibleApply.value = false : dialogFormVisibleApply = false),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};